// import React, { useState, useEffect } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import logo from '../assets/images/logo.png';
// import Sidebar from './Sidebar';
// import SearchMenu from './SeachMenu';
// const Header = () => {
//   const [isServicesOpen, setServicesOpen] = useState(false);
//   const [isSidebarOpen, setSidebarOpen] = useState(false);
//   const [isTrainingOpen, setTrainingOpen] = useState(false);
//   const closeTraining = () => setTrainingOpen(false);
//   const navigate = useNavigate();
//   const toggleSidebar = () => {
//     setSidebarOpen(!isSidebarOpen);
//   };
// // const toggleServices = (e) => {
// //   e.preventDefault();         
// //   e.stopPropagation();
// //   setServicesOpen((p) => !p);
// // };

// const closeServices = () => setServicesOpen(false);
//   const [isSearchOpen, setSearchOpen] = useState(false);
//   const toggleSearch = () => {
//     setSearchOpen(!isSearchOpen);
//   };

//   useEffect(() => {
//     const $ = window.$;

//     const timeout = setTimeout(() => {
//       // Cart sidebar open
//       $(".offset-side-bar").on("click", function (e) {
//         e.preventDefault();
//         e.stopPropagation();
//         $(".cart-group").addClass("isActive");
//       });

//       // Cart sidebar close
//       $(".close-side-widget").on("click", function (e) {
//         e.preventDefault();
//         $(".cart-group").removeClass("isActive");
//       });

//       // Info sidebar open
//       $(".navSidebar-button").on("click", function (e) {
//         e.preventDefault();
//         e.stopPropagation();
//         $(".info-group").addClass("isActive");
//       });

//       // Info sidebar close
//       $(".close-side-widget").on("click", function (e) {
//         e.preventDefault();
//         $(".info-group").removeClass("isActive");
//       });

//       // Close both on body click
//       // $("body").on("click", function () {
//       //   $(".info-group").removeClass("isActive");
//       //   $(".cart-group").removeClass("isActive");
//       //   closeServices();
//       // });
      
//       $("body").on("click", function (e) {
//   // ✅ agar header ya menu ke andar click hai to kuch close mat karo
//   if (
//     $(e.target).closest(".main-header").length ||
//     $(e.target).closest(".mobile-menu").length
//   ) {
//     return;
//   }

//   $(".info-group").removeClass("isActive");
//   $(".cart-group").removeClass("isActive");
//   closeServices();
//   closeTraining();
// });


//       // Prevent click propagation inside widget
//       $(".xs-sidebar-widget").on("click", function (e) {
//         e.stopPropagation();
//       });

//       // Initialize magnificPopup
//       if ($(".xs-modal-popup").length) {
//         $(".xs-modal-popup").magnificPopup({
//           type: "inline",
//           fixedContentPos: false,
//           fixedBgPos: true,
//           overflowY: "auto",
//           closeBtnInside: false,
//           callbacks: {
//             beforeOpen: function () {
//               this.st.mainClass = "my-mfp-slide-bottom xs-promo-popup";
//             }
//           }
//         });
//       }

//       //Header Search
//       if ($('.search-box-outer').length) {
//         $('.search-box-outer').on('click', function () {
//           $('body').addClass('search-active');
//         });
//         $('.close-search').on('click', function () {
//           $('body').removeClass('search-active');
//         });
//       }

//       //Mobile Nav Hide Show
//       // if ($('.mobile-menu').length) {
//       //   $('.mobile-menu .menu-box').mCustomScrollbar();

//       // const mobileMenuContent = $('.main-header .nav-outer .main-menu').html();
//       // if (!$('.mobile-menu .menu-box .menu-outer .navigation').length) {
//       //   $('.mobile-menu .menu-box .menu-outer').append(mobileMenuContent);
//       // }

//       //   //Dropdown Button
//       //   $('.mobile-menu li.dropdown .dropdown-btn').on('click', function () {
//       //     $(this).toggleClass('open');
//       //     $(this).prev('ul').slideToggle(500);
//       //   });
//       //   //Menu Toggle Btn
//       //   $('.mobile-nav-toggler').on('click', function () {
//       //     $('body').addClass('mobile-menu-visible');
//       //   });

//       //   //Menu Toggle Btn
//       //   $('.mobile-menu .menu-backdrop,.mobile-menu .close-btn').on('click', function () {
//       //     $('body').removeClass('mobile-menu-visible');
//       //   });

//       // }


// // if ($('.mobile-menu').length) {
// //   $('.mobile-menu .menu-box').mCustomScrollbar();

// //   // 👇 Sab purana mobile menu content hatao
// //   $('.mobile-menu .menu-box .menu-outer').empty();

// //   // 👇 Desktop nav se fresh HTML lo
// //   const mobileMenuContent = $('.main-header .nav-outer .main-menu').html();

// //   // 👇 Ek hi baar inject karo
// //   $('.mobile-menu .menu-box .menu-outer').append(mobileMenuContent);

// //   // Dropdown Button
// //   $('.mobile-menu li.dropdown .dropdown-btn').on('click', function () {
// //     $(this).toggleClass('open');
// //     $(this).prev('ul').slideToggle(500);
// //   });

// //   // Menu Toggle Btn
// //   $('.mobile-nav-toggler').on('click', function () {
// //     $('body').addClass('mobile-menu-visible');
// //   });

// //   $('.mobile-menu .menu-backdrop,.mobile-menu .close-btn').on('click', function () {
// //     $('body').removeClass('mobile-menu-visible');
// //   });
// // }
// if ($('.mobile-menu').length) {
//   $('.mobile-menu .menu-box').mCustomScrollbar();

//   const $menuOuter = $('.mobile-menu .menu-box .menu-outer');

//   // purge old content
//   $menuOuter.empty();

//   // sirf UL copy karo, pura main-menu nahi
//  if ($menuOuter.find('ul.navigation').length === 0) {
//   const mobileMenuContent = $('.header-upper .nav-outer .main-menu .navbar-collapse > ul.navigation')
//     .first()
//     .clone();
//   $menuOuter.append(mobileMenuContent);
// }

//   // Dropdown Button
//   // $('.mobile-menu li.dropdown .dropdown-btn').on('click', function () {
//   //   $(this).toggleClass('open');
//   //   $(this).prev('ul').slideToggle(500);
//   // });

//   // Menu Toggle Btn
//   $('.mobile-nav-toggler').on('click', function () {
//     $('body').addClass('mobile-menu-visible');
//   });

//   $('.mobile-menu .menu-backdrop,.mobile-menu .close-btn').on('click', function () {
//     $('body').removeClass('mobile-menu-visible');
//   });

//   // ---- after cloning ul.navigation into $menuOuter ----

// // 1) Dropdown icon inject karo (agar missing ho)
// /* Services ke li ke andar ek proper row banane ke liye */   
// // $menuOuter.find("li.dropdown").each(function () {
// //   if (!$(this).children(".dropdown-btn").length) {
// //     $(this).append('<div class="dropdown-btn"></div>');
// //   }

// //   const $ul = $(this).children("ul");
// //   if ($ul.length) $ul.hide();
// // });

// // $menuOuter.off("click.mobileBtn").on("click.mobileBtn", ".dropdown-btn", function (e) {
// //   e.preventDefault();
// //   e.stopPropagation();

// //   const $li = $(this).closest("li.dropdown");
// //   $li.toggleClass("open");

// //   $li.children("ul").stop(true, true).slideToggle(300);
// // });
// // 1) Ensure dropdown button exists + icon add
// $menuOuter.find("li.dropdown").each(function () {
//   if (!$(this).children(".dropdown-btn").length) {
//     $(this).append('<div class="dropdown-btn"><span class="fa fa-angle-down"></span></div>');
//   }

//   // submenu hide by default (mobile)
//   const $ul = $(this).children("ul");
//   if ($ul.length) $ul.hide();
// });

// // 2) Dropdown icon click -> ONLY toggle submenu
// $menuOuter
//   .off("click.mobileDrop")
//   .on("click.mobileDrop", ".dropdown-btn", function (e) {
//     e.preventDefault();
//     e.stopPropagation();

//     const $li = $(this).closest("li.dropdown");
//     $li.toggleClass("open");
//     $li.children("ul").stop(true, true).slideToggle(250);
//   });

// // 3) (Important) Mobile me Services text pe click = navigate (submenu toggle nahi)
// $menuOuter
//   .off("click.mobileLinkGuard")
//   .on("click.mobileLinkGuard", "li.dropdown > a", function (e) {
//     // icon ke area me click hua ho to navigation roko (extra safety)
//     if ($(e.target).closest(".dropdown-btn").length) {
//       e.preventDefault();
//       e.stopPropagation();
//     }
//   });


// }

//     }, 300);

    
//     return () => {
//       clearTimeout(timeout);
//       // Optional: Unbind events here if component unmounts
//       $(".offset-side-bar").off("click");
//       $(".close-side-widget").off("click");
//       $(".navSidebar-button").off("click");
//       $("body").off("click");
//       $(".xs-sidebar-widget").off("click");
//       $('.search-box-outer').off("click");
//       $('.close-search').off("click");
//       const $menuOuter = $('.mobile-menu .menu-box .menu-outer');
//       $menuOuter.off("click.mobileDrop");
//   $menuOuter.off("click.mobileLinkGuard");
//     };
//   }, []);

//    const location = useLocation();
//   const currentPath = location.pathname;
//   useEffect(() => {
//   closeServices();
//    closeTraining();
// }, [currentPath]);
// useEffect(() => {
//   const onScroll = () => {
//     const shouldFix = window.scrollY > 120;
//     document.body.classList.toggle("fixed-header", shouldFix);

//     const headerUpper = document.querySelector(".main-header .header-upper");
//     if (headerUpper) {
//       const h = headerUpper.offsetHeight || 0;
//       document.body.style.paddingTop = shouldFix ? `${h}px` : "0px";
//     }
//   };

//   window.addEventListener("scroll", onScroll, { passive: true });
//   onScroll();
//   return () => window.removeEventListener("scroll", onScroll);
// }, []);


//   return (
//     <div>
//       <header className="main-header header-style-one">
//         {/* Header Top */}
//         <div className="header-top">
//           <div className="auto-container">
//             <div className="clearfix">
//               {/* Top Left */}
//               <div className="top-left">
//                 <ul className="info-list">
//                 <li>
//                   <a href="tel:+919978623133">
//                     <i class="fa fa-phone"></i> 91 99786 23133
//                   </a>
//                 </li>
//                 <li>
//                   <a href="mailto:swiftmazetech@gmail.com">
//                     <i class="fa fa-envelope"></i> swiftmazetech@gmail.com
//                   </a>
//                 </li>
//               </ul>

//               </div>
//               {/* Top Right */}
//               <div className="top-right pull-right">
//                 <ul class="social-icons">
//                 <li><a href="https://www.facebook.com/swiftmazetech/" class="fa fa-facebook-f"></a></li>
//                 <li><a href="https://www.instagram.com/swiftmazetech" class="fa fa-instagram"></a></li>
//                 <li><a href="https://www.youtube.com/@SwiftMazeTech" class="fa fa-youtube"></a></li>
//                 <li><a href="https://www.linkedin.com/company/swiftmaze-tech-pvt-ltd/" class="fa fa-linkedin"></a></li>
//               </ul>

//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Header Upper */}
//         <div className="header-upper">
//           <div className="auto-container clearfix">
//             <div className="pull-left logo-box">
//               <div className="logo"><a href="/"><img src={logo} alt="" title="" /></a></div>
//             </div>
//             <div className="nav-outer clearfix">
//               <div className="mobile-nav-toggler"><span className="icon flaticon-menu"></span></div>
//               <nav className="main-menu navbar-expand-md">
//                 <div className="navbar-header">
//                   <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//                     <span className="icon-bar"></span>
//                     <span className="icon-bar"></span>
//                     <span className="icon-bar"></span>
//                   </button>
//                 </div>
//                 <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent">
//                   <ul className="navigation clearfix">
//                     <li className={currentPath === "/" ? "current" : ""}><Link to="/">Home</Link></li>
//                     {/* <li
//                     className={`dropdown ${isServicesOpen ? "open" : ""} ${currentPath.startsWith("/services") ? "current" : ""}`}
//                     onMouseEnter={() => {
//                       if (window.innerWidth >= 992) setServicesOpen(true);
//                     }}
//                     onMouseLeave={() => {
//                       if (window.innerWidth >= 992) setServicesOpen(false);
//                     }}
//                   >
                 
//                       <Link
//                           to="/services"
//                           onClickCapture={(e) => {
//                             // ✅ Desktop/Web: force navigation (theme JS click block kare to bhi)
//                             if (window.innerWidth >= 992) {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               closeServices();
//                               closeTraining();
//                               navigate("/services");
//                             }
//                           }}
//                           onClick={() => {
//                             // ✅ Mobile: normal Link behavior (open /services)
//                             closeServices();
//                           }}
//                         >
//                           Services
//                         </Link>


//   <ul style={{ display: isServicesOpen ? "block" : "none" }}>
//     <li><Link to="/services/extension-development" onClick={closeServices}>Extension Development</Link></li>
//     <li><Link to="/services/web-development" onClick={closeServices}>Web Development</Link></li>
//     <li><Link to="/services/erp-development" onClick={closeServices}>ERP system</Link></li>
//     <li><Link to="/services/crm-development" onClick={closeServices}>CRM System</Link></li>
//     <li><Link to="/services/qa-testing" onClick={closeServices}>QA & Testing</Link></li>
//     <li><Link to="/services/website-development-modasa" onClick={closeServices}>Website Development Modasa</Link></li>
//     <li><Link to="/services/digital-marketing-modasa" onClick={closeServices}>Digital Marketing Modasa</Link></li>
//     <li><Link to="/services/software-development-company-modasa" onClick={closeServices}>Software Development Modasa</Link></li>
//   </ul>
// </li> */}


//    <li
//   className={`dropdown ${isServicesOpen ? "open" : ""} ${currentPath.startsWith("/services") ? "current" : ""}`}
//   onMouseEnter={() => {
//     if (window.innerWidth >= 992) setServicesOpen(true);
//   }}
//   onMouseLeave={() => {
//     if (window.innerWidth >= 992) setTimeout(() => setServicesOpen(false), 180);
//   }}
// >


// <Link
//   to="/services"
//   onClickCapture={(e) => {
//     // If any theme jQuery blocks dropdown parent clicks, kill it
//     e.nativeEvent?.stopImmediatePropagation?.();
//   }}
//   onClick={() => {
//     closeServices();
//     closeTraining();
//   }}
// >
//   Services
// </Link>

//   <ul style={{ display: isServicesOpen ? "block" : "none" }}>
//     <li><Link to="/services/extension-development" onClick={closeServices}>Extension Development</Link></li>
//     <li><Link to="/services/web-development" onClick={closeServices}>Web Development</Link></li>
//     <li><Link to="/services/erp-development" onClick={closeServices}>ERP system</Link></li>
//     <li><Link to="/services/crm-development" onClick={closeServices}>CRM System</Link></li>
//     <li><Link to="/services/qa-testing" onClick={closeServices}>QA & Testing</Link></li>
//     <li><Link to="/services/website-development-modasa" onClick={closeServices}>Website Development Modasa</Link></li>
//     <li><Link to="/services/digital-marketing-modasa" onClick={closeServices}>Digital Marketing Modasa</Link></li>
//     <li><Link to="/services/software-development-company-modasa" onClick={closeServices}>Software Development Modasa</Link></li>
//   </ul>
// </li>

//                     <li
//                     className={`dropdown ${isTrainingOpen ? "open" : ""} ${
//                       currentPath.includes("/services") &&
//                       (
//                         currentPath.includes("internship") ||
//                         currentPath.includes("mentorship") ||
//                         currentPath.includes("project-guidance")
//                       )
//                         ? "current"
//                         : ""
//                     }`}
//                     onMouseEnter={() => {
//                       if (window.innerWidth >= 992) setTrainingOpen(true);
//                     }}
//                     onMouseLeave={() => {
//                       if (window.innerWidth >= 992) setTrainingOpen(false);
//                     }}
//                   >
//                     <Link
//                       to="/services/internship-project-guidance-modasa"
//                       onClick={(e) => {
//                         e.stopPropagation();

//                         // Mobile: dropdown toggle
//                         if (window.innerWidth < 992) {
//                           e.preventDefault();
//                           setTrainingOpen(p => !p);
//                         }
//                         // Desktop: normal navigation allowed
//                       }}
//                     >
//                       Training
//                     </Link>

//                     <ul style={{ display: isTrainingOpen ? "block" : "none" }}>
//                       <li>
//                         <Link
//                           to="/services/bca-internship-industrial-project-guidance"
//                           onClick={closeTraining}
//                         >
//                           BCA Internship & Industrial Project Guidance
//                         </Link>
//                       </li>

//                       <li>
//                         <Link
//                           to="/services/industry-project-internship-mentorship"
//                           onClick={closeTraining}
//                         >
//                           Industry Project, Internship & Mentorship
//                         </Link>
//                       </li>

//                       <li>
//                         <Link
//                           to="/services/internship-project-guidance-modasa"
//                           onClick={closeTraining}
//                         >
//                           Internship & Project Guidance (Modasa)
//                         </Link>
//                       </li>

//                       <li>
//                         <Link
//                           to="/services/btech-be-internship-project-guidance"
//                           onClick={closeTraining}
//                         >
//                           BTech / BE Internship Project Guidance
//                         </Link>
//                       </li>
//                     </ul>
//                   </li>
//                     <li className={currentPath === "/about" ? "current" : ""}><Link to="/about">About</Link></li>
//                    <li className={currentPath === "/contact" ? "current" : ""}><Link to="/contact">Contact us</Link></li>
//                   </ul>
//                 </div>
//               </nav>
//               <div className="outer-box clearfix">
//                 <div className="btn-box">
//                   {/* <Link to="/contact" className="theme-btn btn-style-one"><span className="txt">Free Consulting</span></Link> */}
//                   <a href="https://wa.me/919978623133" className="theme-btn btn-style-one" target="_blank" rel="noopener noreferrer">  <span className="txt">Free Consulting</span> </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* <div class="sticky-header">
//   <div className="auto-container clearfix">
//             <div className="pull-left logo-box">
//               <div className="logo"><a href="/"><img src={logo} alt="" title="" /></a></div>
//             </div>
//             <div className="nav-outer clearfix">
//               <div className="mobile-nav-toggler"><span className="icon flaticon-menu"></span></div>
//               <nav className="main-menu navbar-expand-md">
//                 <div className="navbar-header">
//                   <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//                     <span className="icon-bar"></span>
//                     <span className="icon-bar"></span>
//                     <span className="icon-bar"></span>
//                   </button>
//                 </div>
//                 <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent">
//                   <ul className="navigation clearfix">
//                     <li className={currentPath === "/" ? "current" : ""}><Link to="/">Home</Link></li>
                 
//                    <li className={`dropdown ${isServicesOpen ? "open" : ""} ${currentPath.indexOf("/services") !== -1 ? "current" : ""}`}>
//               <Link to="/services" onClick={toggleServices}>
//                 Services
//               </Link>
//               <ul style={{ display: isServicesOpen ? "block" : "none" }}>
//                 <li><Link to="/services/extension-development" onClick={closeServices}>Extension Development</Link></li>
//                 <li><Link to="/services/web-development" onClick={closeServices}>Web Development</Link></li>
//                 <li><Link to="/services/erp-development" onClick={closeServices}>ERP system</Link></li>
//                 <li><Link to="/services/crm-development" onClick={closeServices}>CRM System</Link></li>
//                 <li><Link to="/QATesting" onClick={closeServices}>QA & Testing</Link></li>
//                 <li><Link to="/services/website-development-modasa" onClick={closeServices}>Website Development Modasa</Link></li>
//                 <li><Link to="/services/digital-marketing-modasa" onClick={closeServices}>Digital Marketing Modasa</Link></li>
//                 <li><Link to="/services/software-development-company-modasa" onClick={closeServices}>Software Development Modasa</Link></li>
//               </ul>
//             </li>


//                     <li className={currentPath === "/about" ? "current" : ""}><Link to="/about">About</Link></li>
//                   <li className={currentPath === "/contact" ? "current" : ""}><Link to="/contact">Contact us</Link></li>
//                   </ul>
//                 </div>
//               </nav>
//               <div className="outer-box clearfix">
//                <div className="btn-box">
//                   <Link to="/contact" className="theme-btn btn-style-one"><span className="txt">Free Consulting</span></Link>
//                 </div>
//               </div>
//             </div>
//           </div>
// </div> */}
//         <div className="mobile-menu">
//   <div className="menu-backdrop"></div>
//   <div className="close-btn"><span className="icon flaticon-multiply"></span></div>
//   <nav className="menu-box">
//     <div className="nav-logo">
//       <Link to="/"><img src="images/logo.png" alt="" title="" /></Link>
//     </div>
//     <div className="menu-outer"></div>
//   </nav>
// </div>

//       </header>
//       {/* Sidebar Component */}
//       <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

//       <SearchMenu isOpen={isSearchOpen} toggleSearch={toggleSearch} />
//     </div>
//   );
// };

// export default Header;





//START Active 28-1
// import React, { useEffect, useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';

// /*
//  * Cleaned up version of the site's header component (JavaScript).
//  *
//  * This component preserves the existing functionality from the
//  * provided implementation (sticky header on scroll, mobile sidebar,
//  * search modal, etc.) while simplifying the structure of the
//  * dropdown menus. Both the "Services" and "Training" menus use a
//  * shared click handler to toggle their respective submenus on
//  * smaller screens. On larger screens (≥ 992px) the dropdowns still
//  * open on hover and clicking the links continues to navigate
//  * normally.
//  */

// import logo from '../assets/images/logo.png';
// import Sidebar from './Sidebar';
// import SearchMenu from './SeachMenu';

// const Header = () => {
//   // State for dropdown menus and off-canvas components
//   const [isServicesOpen, setServicesOpen] = useState(false);
//   const [isTrainingOpen, setTrainingOpen] = useState(false);
//   const [isSidebarOpen, setSidebarOpen] = useState(false);
//   const [isSearchOpen, setSearchOpen] = useState(false);

//   const location = useLocation();
//   const currentPath = location.pathname;

//   // Close dropdowns on route change
//   useEffect(() => {
//     setServicesOpen(false);
//     setTrainingOpen(false);
//   }, [currentPath]);

//   // Sticky header on scroll
//   useEffect(() => {
//     const onScroll = () => {
//       const shouldFix = window.scrollY > 120;
//       document.body.classList.toggle('fixed-header', shouldFix);
//       const headerUpper = document.querySelector('.main-header .header-upper');
//       if (headerUpper) {
//         const h = headerUpper.offsetHeight || 0;
//         document.body.style.paddingTop = shouldFix ? `${h}px` : '0px';
//       }
//     };
//     window.addEventListener('scroll', onScroll, { passive: true });
//     onScroll();
//     return () => window.removeEventListener('scroll', onScroll);
//   }, []);

//   // jQuery integrations: sidebars, modals, mobile navigation
//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       const $ = window.$;
//       if (!$) return;
//       // Cart sidebar open/close
//       $('.offset-side-bar').on('click', function (e) {
//         e.preventDefault();
//         e.stopPropagation();
//         $('.cart-group').addClass('isActive');
//       });
//       $('.close-side-widget').on('click', function (e) {
//         e.preventDefault();
//         $('.cart-group').removeClass('isActive');
//       });
//       // Info sidebar open/close
//       $('.navSidebar-button').on('click', function (e) {
//         e.preventDefault();
//         e.stopPropagation();
//         $('.info-group').addClass('isActive');
//       });
//       $('.close-side-widget').on('click', function (e) {
//         e.preventDefault();
//         $('.info-group').removeClass('isActive');
//       });
//       // Close sidebars when clicking outside
//       $('body').on('click', function (e) {
//         if (
//           $(e.target).closest('.main-header').length ||
//           $(e.target).closest('.mobile-menu').length
//         ) {
//           return;
//         }
//         $('.info-group').removeClass('isActive');
//         $('.cart-group').removeClass('isActive');
//       });
//       // Prevent click propagation inside widgets
//       $('.xs-sidebar-widget').on('click', function (e) {
//         e.stopPropagation();
//       });
//       // MagnificPopup modals
//       if ($('.xs-modal-popup').length) {
//         $('.xs-modal-popup').magnificPopup({
//           type: 'inline',
//           fixedContentPos: false,
//           fixedBgPos: true,
//           overflowY: 'auto',
//           closeBtnInside: false,
//           callbacks: {
//             beforeOpen: function () {
//               this.st.mainClass = 'my-mfp-slide-bottom xs-promo-popup';
//             },
//           },
//         });
//       }
//       // Header search box
//       if ($('.search-box-outer').length) {
//         $('.search-box-outer').on('click', function () {
//           $('body').addClass('search-active');
//         });
//         $('.close-search').on('click', function () {
//           $('body').removeClass('search-active');
//         });
//       }
//       // Mobile menu
//       if ($('.mobile-menu').length) {
//         const $menuOuter = $('.mobile-menu .menu-box .menu-outer');
//         $menuOuter.empty();
//         if ($menuOuter.find('ul.navigation').length === 0) {
//           const mobileMenuContent =
//             $('.header-upper .nav-outer .main-menu .navbar-collapse > ul.navigation')
//               .first()
//               .clone();
//           $menuOuter.append(mobileMenuContent);
//         }
//         $('.mobile-nav-toggler').on('click', function () {
//           $('body').addClass('mobile-menu-visible');
//         });
//         $('.mobile-menu .menu-backdrop, .mobile-menu .close-btn').on(
//           'click',
//           function () {
//             $('body').removeClass('mobile-menu-visible');
//           },
//         );
//         $menuOuter.find('li.dropdown').each(function () {
//           if (!$(this).children('.dropdown-btn').length) {
//             $(this).append(
//               '<div class="dropdown-btn"><span class="fa fa-angle-down"></span></div>',
//             );
//           }
//           const $ul = $(this).children('ul');
//           if ($ul.length) $ul.hide();
//         });
//         $menuOuter
//           .off('click.mobileDrop')
//           .on('click.mobileDrop', '.dropdown-btn', function (e) {
//             e.preventDefault();
//             e.stopPropagation();
//             const $li = $(this).closest('li.dropdown');
//             $li.toggleClass('open');
//             $li.children('ul').stop(true, true).slideToggle(250);
//           });
//         $menuOuter
//           .off('click.mobileLinkGuard')
//           .on('click.mobileLinkGuard', 'li.dropdown > a', function (e) {
//             if ($(e.target).closest('.dropdown-btn').length) {
//               e.preventDefault();
//               e.stopPropagation();
//             }
//           });
//       }
//     }, 300);
//     return () => {
//       clearTimeout(timeout);
//       const $ = window.$;
//       if (!$) return;
//       $('.offset-side-bar').off('click');
//       $('.close-side-widget').off('click');
//       $('.navSidebar-button').off('click');
//       $('body').off('click');
//       $('.xs-sidebar-widget').off('click');
//       $('.search-box-outer').off('click');
//       $('.close-search').off('click');
//       const $menuOuter = $('.mobile-menu .menu-box .menu-outer');
//       $menuOuter.off('click.mobileDrop');
//       $menuOuter.off('click.mobileLinkGuard');
//     };
//   }, []);


//   // Shared handler for dropdown clicks on small screens
//   const handleDropdownClick = (key, e) => { 
//     if (window.innerWidth < 992) {
//       e.preventDefault();
//       e.stopPropagation();
//       if (key === 'services') {
//         setServicesOpen((prev) => !prev);
//         setTrainingOpen(false);
//       } else {
//         setTrainingOpen((prev) => !prev);
//         setServicesOpen(false);
//       }
//     } else {
//       setServicesOpen(false);
//       setTrainingOpen(false);
//     }
//   };

//   return (
//     <div>
//       <header className="main-header header-style-one">
//         {/* Header Top */}
//         <div className="header-top">
//           <div className="auto-container">
//             <div className="clearfix">
//               {/* Top Left */}
//               <div className="top-left">
//                 <ul className="info-list">
//                   <li>
//                     <a href="tel:+919978623133">
//                       <i className="fa fa-phone"></i>
//                       91 99786 23133
//                     </a>
//                   </li>
//                   <li>
//                     <a href="mailto:swiftmazetech@gmail.com">
//                       <i className="fa fa-envelope"></i>
//                       swiftmazetech@gmail.com
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//               {/* Top Right */}
//               <div className="top-right pull-right">
//                 <ul className="social-icons">
//                   <li>
//                     <a
//                       href="https://www.facebook.com/swiftmazetech/"
//                       className="fa fa-facebook-f"
//                     ></a>
//                   </li>
//                   <li>
//                     <a
//                       href="https://www.instagram.com/swiftmazetech"
//                       className="fa fa-instagram"
//                     ></a>
//                   </li>
//                   <li>
//                     <a
//                       href="https://www.youtube.com/@SwiftMazeTech"
//                       className="fa fa-youtube"
//                     ></a>
//                   </li>
//                   <li>
//                     <a
//                       href="https://www.linkedin.com/company/swiftmaze-tech-pvt-ltd/"
//                       className="fa fa-linkedin"
//                     ></a>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Header Upper */}
//         <div className="header-upper">
//           <div className="auto-container clearfix">
//             <div className="pull-left logo-box">
//               <div className="logo">
//                 <Link to="/">
//                   <img src={logo} alt="Swift Maze Tech" title="Swift Maze Tech" />
//                 </Link>
//               </div>
//             </div>
//             <div className="nav-outer clearfix">
//               {/* Mobile nav toggler */}
//               <div className="mobile-nav-toggler">
//                 <span className="icon flaticon-menu"></span>
//               </div>
//               <nav className="main-menu navbar-expand-md">
//                 <div className="navbar-header">
//                   <button
//                     className="navbar-toggler"
//                     type="button"
//                     data-toggle="collapse"
//                     data-target="#navbarSupportedContent"
//                     aria-controls="navbarSupportedContent"
//                     aria-expanded="false"
//                     aria-label="Toggle navigation"
//                   >
//                     <span className="icon-bar"></span>
//                     <span className="icon-bar"></span>
//                     <span className="icon-bar"></span>
//                   </button>
//                 </div>
//                 <div
//                   className="navbar-collapse collapse clearfix"
//                   id="navbarSupportedContent"
//                 >
//                   <ul className="navigation clearfix">
//                     <li className={currentPath === '/' ? 'current' : ''}>
//                       <Link to="/">Home</Link>
//                     </li>
//                     {/* Services dropdown */}
//                     <li
//                       className={
//                         'dropdown ' +
//                         (isServicesOpen ? 'open ' : '') +
//                         (currentPath.startsWith('/services') ? 'current' : '')
//                       }
//                       onMouseEnter={() => {
//                         if (window.innerWidth >= 992) setServicesOpen(true);
//                       }}
//                       onMouseLeave={() => {
//                         if (window.innerWidth >= 992) setServicesOpen(false);
//                       }}
//                     >
//                       <Link
//                         to="/services"
//                         // onClick={(e) => handleDropdownClick('services', e)}
//                       >
//                         Services
//                       </Link>
//                       <button
//                       type="button"
//                       className="dd-hit"
//                       aria-label="Toggle Services"
//                       onClick={(e) => handleDropdownClick('services', e)}
//                     />
//                       <ul style={{ display: isServicesOpen ? 'block' : 'none' }}>
//                         <li>
//                           <Link
//                             to="/services/extension-development"
//                             onClick={() => setServicesOpen(false)}
//                           >
//                             Extension Development
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/web-development"
//                             onClick={() => setServicesOpen(false)}
//                           >
//                             Web Development
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/erp-development"
//                             onClick={() => setServicesOpen(false)}
//                           >
//                             ERP system
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/crm-development"
//                             onClick={() => setServicesOpen(false)}
//                           >
//                             CRM System
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/qa-testing"
//                             onClick={() => setServicesOpen(false)}
//                           >
//                             QA & Testing
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/website-development-modasa"
//                             onClick={() => setServicesOpen(false)}
//                           >
//                             Website Development Modasa
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/digital-marketing-modasa"
//                             onClick={() => setServicesOpen(false)}
//                           >
//                             Digital Marketing Modasa
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/software-development-company-modasa"
//                             onClick={() => setServicesOpen(false)}
//                           >
//                             Software Development Modasa
//                           </Link>
//                         </li>
//                       </ul>
//                     </li>
//                     {/* Training dropdown */}
//                     <li
//                       className={
//                         'dropdown ' +
//                         (isTrainingOpen ? 'open ' : '') +
//                         (currentPath.includes('/services') &&
//                         (currentPath.includes('internship') ||
//                           currentPath.includes('mentorship') ||
//                           currentPath.includes('project-guidance'))
//                           ? 'current'
//                           : '')
//                       }
//                       onMouseEnter={() => {
//                         if (window.innerWidth >= 992) setTrainingOpen(true);
//                       }}
//                       onMouseLeave={() => {
//                         if (window.innerWidth >= 992) setTrainingOpen(false);
//                       }}
//                     >
//                       <Link
//                         to="/services/internship-project-guidance-modasa"
//                         onClick={(e) => handleDropdownClick('training', e)}
//                       >
//                         Training
//                       </Link>
//                       <ul style={{ display: isTrainingOpen ? 'block' : 'none' }}>
//                         <li>
//                           <Link
//                             to="/services/bca-internship-industrial-project-guidance"
//                             onClick={() => setTrainingOpen(false)}
//                           >
//                             BCA Internship & Industrial Project Guidance
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/industry-project-internship-mentorship"
//                             onClick={() => setTrainingOpen(false)}
//                           >
//                             Industry Project, Internship & Mentorship
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/internship-project-guidance-modasa"
//                             onClick={() => setTrainingOpen(false)}
//                           >
//                             Internship & Project Guidance (Modasa)
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             to="/services/btech-be-internship-project-guidance"
//                             onClick={() => setTrainingOpen(false)}
//                           >
//                             BTech / BE Internship Project Guidance
//                           </Link>
//                         </li>
//                       </ul>
//                     </li>
//                     <li className={currentPath === '/about' ? 'current' : ''}>
//                       <Link to="/about">About</Link>
//                     </li>
//                     <li className={currentPath === '/contact' ? 'current' : ''}>
//                       <Link to="/contact">Contact us</Link>
//                     </li>
//                   </ul>
//                 </div>
//               </nav>
//               <div className="outer-box clearfix">
//                 <div className="btn-box">
//                   {/* External link for free consulting */}
//                   <a
//                     href="https://wa.me/919978623133"
//                     className="theme-btn btn-style-one"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     <span className="txt">Free Consulting</span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Mobile Menu Structure (populated via jQuery) */}
//         <div className="mobile-menu">
//           <div className="menu-backdrop"></div>
//           <div className="close-btn">
//             <span className="icon flaticon-multiply"></span>
//           </div>
//           <nav className="menu-box">
//             <div className="nav-logo">
//               <Link to="/">
//                 <img src={logo} alt="Swift Maze Tech" title="Swift Maze Tech" />
//               </Link>
//             </div>
//             <div className="menu-outer"></div>
//           </nav>
//         </div>
//       </header>
//       {/* Sidebar component (cart/info) */}
//       <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={() => setSidebarOpen((p) => !p)}
//       />
//       {/* Search modal component */}
//       <SearchMenu
//         isOpen={isSearchOpen}
//         toggleSearch={() => setSearchOpen((p) => !p)}
//       />
//     </div>
//   );
// };

// export default Header;

//END Active 28-1



import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

/*
 * Cleaned up version of the site's header component.
 *
 * This component preserves all existing functionality from the
 * provided implementation (sticky header on scroll, mobile
 * sidebar/menu integration via jQuery, search modal, etc.) while
 * simplifying the structure of the dropdown menus. Both the
 * "Services" and "Training" menus use a shared click handler to
 * toggle their respective submenus on smaller screens. On larger
 * screens (≥ 992px) the dropdowns still open on hover and
 * clicking the links continues to navigate normally.
 */

import logo from '../assets/images/swiftmaze-header-logo.png';
import Sidebar from './Sidebar';
import SearchMenu from './SeachMenu';
import trainingMenuItems from './trainingMenuItems';
import serviceMenuItems from './serviceMenuItems';
import productMenuItems from './productMenuItems';

const Header = () => {
  // State for dropdown menus and off-canvas components
  const [isServicesOpen, setServicesOpen] = useState(false);
  const [isProductsOpen, setProductsOpen] = useState(false);
  const [isTrainingOpen, setTrainingOpen] = useState(false);
  const [isAboutOpen, setAboutOpen] = useState(false);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isSearchOpen, setSearchOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const normalizePath = (path) =>
    path && path.length > 1 ? path.replace(/\/+$/, '') : path;
  const isCurrentMenuPath = (path) =>
    normalizePath(path) === normalizePath(currentPath);
  const trainingRootPath =
    trainingMenuItems[0]?.to || '/training/internship-project-guidance-modasa';
  const isTrainingRoute = trainingMenuItems.some((item) => isCurrentMenuPath(item.to));
  const isServiceRoute = currentPath.startsWith('/services') && !isTrainingRoute;
  const isProductRoute = currentPath.startsWith('/products');

  /**
   * Close both dropdowns whenever the current route changes. This
   * prevents the dropdowns from staying open when navigating to a
   * different page.
   */
  useEffect(() => {
    setServicesOpen(false);
    setProductsOpen(false);
    setTrainingOpen(false);
    setAboutOpen(false);
  }, [currentPath]);

  /**
   * Make the header sticky when scrolling past a threshold. The
   * padding-top on the body is adjusted to avoid content jump.
   */
  useEffect(() => {
    const onScroll = () => {
      const shouldFix = window.scrollY > 120;
      document.body.classList.toggle('fixed-header', shouldFix);
      const headerUpper = document.querySelector('.main-header .header-upper');
      if (headerUpper) {
        const h = headerUpper.offsetHeight || 0;
        document.body.style.paddingTop = shouldFix ? `${h}px` : '0px';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    // run once on mount
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  /**
   * Initialize jQuery-based UI interactions such as sidebars,
   * magnificPopup modals and the mobile navigation menu. These
   * integrations mirror the original implementation and will run
   * after the component mounts.
   */
  useEffect(() => {
    // Timeout ensures DOM elements are present before binding
    const timeout = setTimeout(() => {
      const $ = window.$;
      // Guard against jQuery not being loaded
      if (!$) return;
      // Open and close cart sidebar
      $('.offset-side-bar').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.cart-group').addClass('isActive');
      });
      $('.close-side-widget').on('click', function (e) {
        e.preventDefault();
        $('.cart-group').removeClass('isActive');
      });
      // Open and close info sidebar
      $('.navSidebar-button').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.info-group').addClass('isActive');
      });
      $('.close-side-widget').on('click', function (e) {
        e.preventDefault();
        $('.info-group').removeClass('isActive');
      });
      // Close sidebars when clicking outside
      $('body').on('click', function (e) {
        if (
          $(e.target).closest('.main-header').length ||
          $(e.target).closest('.mobile-menu').length
        ) {
          return;
        }
        $('.info-group').removeClass('isActive');
        $('.cart-group').removeClass('isActive');
      });
      // Prevent click propagation inside widgets
      $('.xs-sidebar-widget').on('click', function (e) {
        e.stopPropagation();
      });
      // Initialize magnificPopup modals
      if ($('.xs-modal-popup').length) {
        $('.xs-modal-popup').magnificPopup({
          type: 'inline',
          fixedContentPos: false,
          fixedBgPos: true,
          overflowY: 'auto',
          closeBtnInside: false,
          callbacks: {
            beforeOpen: function () {
              this.st.mainClass = 'my-mfp-slide-bottom xs-promo-popup';
            },
          },
        });
      }
      // Header search box
      if ($('.search-box-outer').length) {
        $('.search-box-outer').on('click', function () {
          $('body').addClass('search-active');
        });
        $('.close-search').on('click', function () {
          $('body').removeClass('search-active');
        });
      }
      // Theme script disables parent dropdown links; undo that so Services/Training navigate
      $('.main-header .navigation li.dropdown > a').off('click');
      $('.navigation li.dropdown > a').off('click');
      // Remove theme-injected dropdown buttons in the main header (we use dd-hit)
      $('.main-header li.dropdown .dropdown-btn').remove();
      // Mobile navigation menu: copy desktop navigation and add dropdown buttons
      if ($('.mobile-menu').length) {
        const $menuOuter = $('.mobile-menu .menu-box .menu-outer');
        // purge old content
        $menuOuter.empty();
        // Copy the main navigation's unordered list
        if ($menuOuter.find('ul.navigation').length === 0) {
          const mobileMenuContent =
            $('.header-upper .nav-outer .main-menu .navbar-collapse > ul.navigation')
              .first()
              .clone();
          $menuOuter.append(mobileMenuContent);
        }
        // Show mobile menu
        $('.mobile-nav-toggler').on('click', function () {
          $('body').addClass('mobile-menu-visible');
        });
        // Hide mobile menu
        $('.mobile-menu .menu-backdrop, .mobile-menu .close-btn').on(
          'click',
          function () {
            $('body').removeClass('mobile-menu-visible');
          },
        );
        // Add dropdown buttons to li.dropdown items and hide submenus by default
        $menuOuter.find('li.dropdown').each(function () {
          if (!$(this).children('.dropdown-btn').length) {
            $(this).append(
              '<div class="dropdown-btn"><span class="fa fa-angle-down"></span></div>',
            );
          }
          $(this)
            .children('.dropdown-btn')
            .find('span')
            .removeClass('fa-angle-up')
            .addClass('fa-angle-down');
          const $ul = $(this).children('ul');
          if ($ul.length) $ul.hide();
        });
        // Dropdown icon click toggles submenu
        $menuOuter
          .off('click.mobileDrop')
          .on('click.mobileDrop', '.dropdown-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $li = $(this).closest('li.dropdown');
            $li.toggleClass('open');
            $(this)
              .find('span')
              .toggleClass('fa-angle-up', $li.hasClass('open'))
              .toggleClass('fa-angle-down', !$li.hasClass('open'));
            $li.children('ul').stop(true, true).slideToggle(250);
          });
        // Ensure top-level dropdown links navigate on mobile (e.g., Services -> /services)
        $menuOuter
          .off('click.mobileParentNav')
          .on('click.mobileParentNav', 'li.dropdown > a', function (e) {
            if ($(e.target).closest('.dropdown-btn').length) {
              return;
            }
            const href = $(this).attr('href');
            if (!href) return;
            e.preventDefault();
            e.stopPropagation();
            $('body').removeClass('mobile-menu-visible');
            setServicesOpen(false);
            setProductsOpen(false);
            setTrainingOpen(false);
            setAboutOpen(false);
            navigate(href);
          });
      }
    }, 300);
    return () => {
      clearTimeout(timeout);
      // Optional: unbind jQuery events when unmounting
      const $ = window.$;
      if (!$) return;
      $('.offset-side-bar').off('click');
      $('.close-side-widget').off('click');
      $('.navSidebar-button').off('click');
      $('body').off('click');
      $('.xs-sidebar-widget').off('click');
      $('.search-box-outer').off('click');
      $('.close-search').off('click');
      const $menuOuter = $('.mobile-menu .menu-box .menu-outer');
      $menuOuter.off('click.mobileDrop');
      $menuOuter.off('click.mobileParentNav');
    };
  }, []);

  const isTouchLike = () =>
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    (window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(pointer: coarse)').matches);

  /**
   * Shared handler for clicking dropdown parent links on smaller screens
   * or touch devices. Touch devices should open submenus on tap even
   * if the viewport is wide (e.g., iPad landscape).
   */
  const handleDropdownClick = (key, e) => {
    if (window.innerWidth < 992 || isTouchLike()) {
      // Mobile: toggle menus
      e.preventDefault();
      e.stopPropagation();
      if (key === 'services') {
        setServicesOpen((prev) => !prev);
        setProductsOpen(false);
        setTrainingOpen(false);
        setAboutOpen(false);
      } else if (key === 'products') {
        setProductsOpen((prev) => !prev);
        setServicesOpen(false);
        setTrainingOpen(false);
        setAboutOpen(false);
      } else if (key === 'training') {
        setTrainingOpen((prev) => !prev);
        setServicesOpen(false);
        setProductsOpen(false);
        setAboutOpen(false);
      } else {
        setAboutOpen((prev) => !prev);
        setServicesOpen(false);
        setProductsOpen(false);
        setTrainingOpen(false);
      }
    } else {
      // Desktop: close menus when navigating
      setServicesOpen(false);
      setProductsOpen(false);
      setTrainingOpen(false);
      setAboutOpen(false);
    }
  };

  return (
    <div>
      <header className="main-header header-style-one">
        {/* Header Top */}
        <div className="header-top">
          <div className="auto-container">
            <div className="clearfix">
              {/* Top Left */}
              <div className="top-left">
                <ul className="info-list">
                  <li>
                    <a href="tel:+919978623133">
                      <i className="fa fa-phone"></i>
                      91 99786 23133
                    </a>
                  </li>
                  <li>
                    <a href="mailto:swiftmazetech@gmail.com">
                      <i className="fa fa-envelope"></i>
                      swiftmazetech@gmail.com
                    </a>
                  </li>
                </ul>
              </div>
              {/* Top Right */}
              <div className="top-right pull-right">
                <ul className="social-icons">
                  <li>
                    <a
                      href="https://www.facebook.com/swiftmazetech/"
                      className="fa fa-facebook-f"
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/swiftmazetech"
                      className="fa fa-instagram"
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@SwiftMazeTech"
                      className="fa fa-youtube"
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/swiftmaze-tech-pvt-ltd/"
                      className="fa fa-linkedin"
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* Header Upper */}
        <div className="header-upper">
          <div className="auto-container clearfix">
            <div className="pull-left logo-box">
              <div className="logo">
                <Link to="/">
                  <img src={logo} alt="Swift Maze Tech" title="Swift Maze Tech" />
                </Link>
              </div>
            </div>
            <div className="nav-outer clearfix">
              {/* Mobile nav toggler */}
              <div className="mobile-nav-toggler">
                <span className="icon flaticon-menu"></span>
              </div>
              <nav className="main-menu navbar-expand-md">
                <div className="navbar-header">
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                </div>
                <div
                  className="navbar-collapse collapse clearfix"
                  id="navbarSupportedContent"
                >
                  <ul className="navigation clearfix">
                    <li className={currentPath === '/' ? 'current' : ''}>
                      <Link to="/">Home</Link>
                    </li>
                    {/* Services dropdown */}
                    <li
                      className={
                        'dropdown ' +
                        (isServicesOpen ? 'open ' : '') +
                        (isServiceRoute ? 'current' : '')
                      }
                      onMouseEnter={() => {
                        if (window.innerWidth >= 992 && !isTouchLike())
                          setServicesOpen(true);
                      }}
                      onMouseLeave={() => {
                        if (window.innerWidth >= 992 && !isTouchLike())
                          setServicesOpen(false);
                      }}
                    >
                      {/* Primary link: navigate to Services page on click */}
                      <Link
                        to="/services/"
                        onClickCapture={(e) => {
                          // Force navigation on non-touch desktops even if theme scripts block the click
                          if (!isTouchLike() && window.innerWidth >= 992) {
                            e.preventDefault();
                            e.stopPropagation();
                            setServicesOpen(false);
                            setProductsOpen(false);
                            setTrainingOpen(false);
                            navigate('/services');
                          }
                        }}
                      >
                        Services
                      </Link>
                      {/* Separate toggle button for the dropdown. Clicking this only toggles the submenu (mobile) */}
                      <button
                        type="button"
                        className="dd-hit"
                        aria-label="Toggle Services"
                        onClick={(e) => handleDropdownClick('services', e)}
                      />
                      <ul
                        className="header-scroll-dropdown header-services-dropdown"
                        style={{ display: isServicesOpen ? 'block' : 'none' }}
                      >
                        {serviceMenuItems.map((item) => (
                          <li
                            key={item.to}
                            className={[
                              item.children?.length ? 'dropdown' : '',
                              isCurrentMenuPath(item.to) ? 'current' : '',
                              item.children?.some((child) => isCurrentMenuPath(child.to))
                                ? 'current'
                                : '',
                            ]
                              .filter(Boolean)
                              .join(' ')}
                          >
                            <Link
                              className="header-menu-link"
                              to={item.to}
                              onClick={() => setServicesOpen(false)}
                            >
                              <span className="header-menu-link-label">
                                {item.label}
                              </span>
                              {item.badge ? (
                                <span className="header-menu-badge">{item.badge}</span>
                              ) : null}
                            </Link>
                            {item.children?.length ? (
                              <ul>
                                {item.children.map((child) => (
                                  <li
                                    key={child.to}
                                    className={isCurrentMenuPath(child.to) ? 'current' : ''}
                                  >
                                    <Link to={child.to} onClick={() => setServicesOpen(false)}>
                                      {child.label}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            ) : null}
                          </li>
                        ))}
                      </ul>
                    </li>
                    {/* Products dropdown */}
                    <li
                      className={
                        'dropdown ' +
                        (isProductsOpen ? 'open ' : '') +
                        (isProductRoute ? 'current' : '')
                      }
                      onMouseEnter={() => {
                        if (window.innerWidth >= 992 && !isTouchLike())
                          setProductsOpen(true);
                      }}
                      onMouseLeave={() => {
                        if (window.innerWidth >= 992 && !isTouchLike())
                          setProductsOpen(false);
                      }}
                    >
                      <Link
                        to="/products/whatsapp-crm/"
                        onClickCapture={(e) => {
                          if (!isTouchLike() && window.innerWidth >= 992) {
                            e.preventDefault();
                            e.stopPropagation();
                            setServicesOpen(false);
                            setProductsOpen(false);
                            setTrainingOpen(false);
                            navigate('/products/whatsapp-crm');
                          }
                        }}
                      >
                        Products
                      </Link>
                      <button
                        type="button"
                        className="dd-hit"
                        aria-label="Toggle Products"
                        onClick={(e) => handleDropdownClick('products', e)}
                      />
                      <ul
                        className="header-scroll-dropdown header-products-dropdown"
                        style={{ display: isProductsOpen ? 'block' : 'none' }}
                      >
                        {productMenuItems.map((item) => (
                          <li
                            key={item.to}
                            className={isCurrentMenuPath(item.to) ? 'current' : ''}
                          >
                            <Link
                              className="header-menu-link"
                              to={item.to}
                              onClick={() => setProductsOpen(false)}
                            >
                              <span className="header-menu-link-label">
                                {item.label}
                              </span>
                              {item.badge ? (
                                <span className="header-menu-badge">{item.badge}</span>
                              ) : null}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                    {/* Training dropdown */}
                    <li
                      className={
                        'dropdown ' +
                        (isTrainingOpen ? 'open ' : '') +
                        (isTrainingRoute ? 'current' : '')
                      }
                      onMouseEnter={() => {
                        if (window.innerWidth >= 992 && !isTouchLike())
                          setTrainingOpen(true);
                      }}
                      onMouseLeave={() => {
                        if (window.innerWidth >= 992 && !isTouchLike())
                          setTrainingOpen(false);
                      }}
                    >
                      {/* Primary link: navigate to Training page on click */}
                      <Link to={trainingRootPath}>
                        Training
                      </Link>
                      {/* Separate toggle button for the dropdown. Clicking this only toggles the submenu (mobile) */}
                      <button
                        type="button"
                        className="dd-hit"
                        aria-label="Toggle Training"
                        onClick={(e) => handleDropdownClick('training', e)}
                      />
                      <ul
                        className="header-scroll-dropdown header-training-dropdown"
                        style={{ display: isTrainingOpen ? 'block' : 'none' }}
                      >
                        {trainingMenuItems.map((item) => (
                          <li
                            key={item.to}
                            className={isCurrentMenuPath(item.to) ? 'current' : ''}
                          >
                            <Link
                              to={item.to}
                              onClick={() => setTrainingOpen(false)}
                            >
                              {item.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                    <li
                      className={
                        'dropdown ' +
                        (isAboutOpen ? 'open ' : '') +
                        (currentPath === '/about' || currentPath === '/contact' ? 'current' : '')
                      }
                      onMouseEnter={() => {
                        if (window.innerWidth >= 992 && !isTouchLike()) setAboutOpen(true);
                      }}
                      onMouseLeave={() => {
                        if (window.innerWidth >= 992 && !isTouchLike()) setAboutOpen(false);
                      }}
                    >
                      <Link to="/about/">About</Link>
                      <button
                        type="button"
                        className="dd-hit"
                        aria-label="Toggle About"
                        onClick={(e) => handleDropdownClick('about', e)}
                      />
                      <ul style={{ display: isAboutOpen ? 'block' : 'none' }}>
                        <li className={currentPath === '/about' ? 'current' : ''}>
                          <Link to="/about/" onClick={() => setAboutOpen(false)}>About Us</Link>
                        </li>
                        <li className={currentPath === '/contact' ? 'current' : ''}>
                          <Link to="/contact/" onClick={() => setAboutOpen(false)}>Contact Us</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a href="https://www.swiftmazetech.com/blog/">Blog</a>
                    </li>
                  </ul>
                </div>
              </nav>
              <div className="outer-box clearfix">
                <div className="btn-box">
                  {/* External link for free consulting */}
                  <a
                    href="https://wa.me/919978623133?text=Hello%20SwiftMaze%20Tech%2C%20I%20am%20contacting%20you%20from%20the%20SwiftMaze%20Tech%20website%20for%20a%20free%20consultation."
                    className="theme-btn btn-style-one"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="txt">Free Consulting</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Menu Structure (populated via jQuery) */}
        <div className="mobile-menu">
          <div className="menu-backdrop"></div>
          <div className="close-btn">
            <span className="icon flaticon-multiply"></span>
          </div>
          <nav className="menu-box">
            <div className="nav-logo">
              <Link to="/">
                <img src={logo} alt="Swift Maze Tech" title="Swift Maze Tech" />
              </Link>
            </div>
            <div className="menu-outer"></div>
          </nav>
        </div>
      </header>
      {/* Sidebar component (cart/info) */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setSidebarOpen((p) => !p)} />
      {/* Search modal component */}
      <SearchMenu isOpen={isSearchOpen} toggleSearch={() => setSearchOpen((p) => !p)} />
    </div>
  );
};

export default Header;
